import { useContext } from 'react';
import { CrimesChartsDataContext } from '../contexts/CrimesChartsDataContext';

export const useCrimesChartsDataContext = () => {
    return useContext(CrimesChartsDataContext);
};
